import './eqc-parallax.scss'
import $ from 'jquery'
import '../../common/js/lazyload/lazyload'
import 'resize-end'
// import { TweenLite, Power2 } from 'gsap'

$(window).on('resizeend', function () {
  // $('.brandhub-paragraph-col img').lazyLoadXT()
})

$(document).ready(function () {
  let parallax = $('.brandhub-parallax-text-image-section')
  if (parallax.length) {
    let dom = {}
    dom.container = $(this)
    dom.window = $(window)
    dom.bodyHtml = $('body,html')
    dom.body = $('body')

    let app = {
      obj: {},
      params: {
        resizeHeight: 0,
        resizeSpeed: 0,
        scrollTop: 0,
        scrollTopTarget: 'eqc' // 'eqc' targets the eqc's window.eqc.params.page.scrollTop value. set this to null for normal scrollTop of window/page/body
      },
      parallax: [],
      sticky: [],
      scrollTrigger: [],
      init: () => {
        console.log('init ecq-parallax')
        $('[data-parallax]').each((index, element) => {
          let $el = $(element)
          let obj = {
            dom: $el,
            target: $el,
            speed: $el.data('parallax'),
            top: 0,
            height: 0,
            percent: 0,
            targetHeight: 0,
            started: false,
            trigger: $(this).data('trigger')
          }
          if (obj.dom.data('target')) {
            if (obj.dom.data('target') === 'parent') {
              obj.target = obj.dom.parent()
            } else {
              obj.target = obj.closest(obj.target)
            }
          }
          app.parallax.push(obj)
        })
        $('.brandhub-parallax-sticky').each((index, element) => {
          let $el = $(element)
          let obj = {
            dom: $el,
            container: $el.closest('.brandhub-parallax-sticky-container'),
            trigger: 'center',
            containerTop: 0,
            containerHeight: 0,
            domTop: 0,
            domHeight: 0
          }
          app.sticky.push(obj)
        })
        $('[data-sticky]').each((index, element) => {
          let $el = $(element)
          let obj = {
            dom: $el,
            container: $el.data('sticky') === 'parent' ? $el.parent() : $el.closest($el.data('sticky')),
            trigger: $el.data('trigger'),
            containerTop: 0,
            containerHeight: 0,
            domTop: 0,
            domHeight: 0
          }
          app.sticky.push(obj)
        })
        $('[data-scrolltrigger]').each((index, element) => {
          let $el = $(element)
          // data-scrolltrigger="css" data-element=".image-mask" data-class="active" data-onenter="function"
          let type = $el.data('scrolltrigger')
          let target = $el.data('element')
          let css = $el.data('class')
          let js = $el.data('onenter')
          let section = $el.closest('section')
          let obj = {
            dom: $el,
            section: section,
            domTop: 0,
            domHeight: 0,
            target: target.indexOf('#') > -1 ? $(target) : target.indexOf('.') > -1 ? section.find(target) : $el,
            type: type || 'css',
            css: css,
            js: js,
            active: false
          }
          app.scrollTrigger.push(obj)
        })
        app.events()
        window.eqc.scrollHooks.parallax = (top) => {
          if (top !== app.params.scrollTop) {
            app.params.scrollTop = top * 1
            app.update()
          }
        }
      },
      events: () => {
        app.resize()
        $(window).on('resize', app.resize)
      },
      resize: () => {
        app.params.height = dom.window.height()
        app.params.width = dom.window.width()
        for (let i = 0; i < app.parallax.length; i++) {
          app.parallax[i].targetHeight = app.parallax[i].target.outerHeight()
        }
        for (let i = 0; i < app.sticky.length; i++) {
          let current = app.sticky[i]
          app.sticky[i].domHeight = current.dom.outerHeight()
          app.sticky[i].containerHeight = current.container.outerHeight()
        }
      },
      update: () => {
        for (let i = 0; i < app.parallax.length; i++) {
          let targetTop = app.parallax[i].target.offset().top
          let off = targetTop - app.params.height / 2
          app.parallax[i].dom.css('transform', 'translate(0,' + (off * app.parallax[i].speed) + 'px)')
        }
        for (let i = 0; i < app.sticky.length; i++) {
          let current = app.sticky[i]
          let trigger = current.trigger === 'center' ? app.params.height / 2 : current.trigger === 'bottom' ? app.params.height : 0 // center or top
          app.sticky[i].containerTop = current.container.offset().top
          app.sticky[i].domTop = current.dom.offset().top
          if (current.containerTop <= app.params.height && current.containerTop > current.containerHeight * -1) {
            if (current.containerTop <= trigger - current.domHeight / 2) {
              app.sticky[i].domTop = (trigger - current.domHeight / 2) - current.containerTop
              if (current.containerTop + current.containerHeight <= trigger + current.domHeight / 2) {
                app.sticky[i].domTop = current.containerHeight - current.domHeight
              }
            } else {
              app.sticky[i].domTop = 0
            }
            current.dom.css('top', current.domTop)
          }
        }
        for (let i = 0; i < app.scrollTrigger.length; i++) {
          let current = app.scrollTrigger[i]
          app.scrollTrigger[i].domTop = current.dom.offset().top
          if (current.domTop < app.params.height / 2 && !current.active) {
            if (current.type === 'css') {
              app.scrollTrigger[i].active = true
              current.target.addClass(current.css)
            }
          } else if (current.domTop >= app.params.height / 2 && current.active) {
            if (current.type === 'css') {
              app.scrollTrigger[i].active = false
              current.target.removeClass(current.css)
            }
          }
        }
      }
    }

    app.init()
    window.parallax = app
  }
})



// WEBPACK FOOTER //
// ./src/components/eqc/eqc-parallax.js